import React from "react"
import {
  useEnterpriseGetOne,
  useMainEnterpriseId,
} from "../../hooks/enterprise"
import { useShopGetOne, useShopId } from "../../hooks/shop"
import { useAtom as GetAtom } from "jotai"
import { checkoutStepAtom } from "../../store/checkout"
import { ArrowLeft } from "lucide-react"
import { Button } from "@malond/ui/components/button"
import { useRouter } from "next/router"
import queryString from "query-string"
import { useShopSalePointId } from "../../hooks/shopSalePoint"
import { useItemSearchText } from "../../hooks/item"

export default function CheckoutBackButton() {
  const router = useRouter()

  const enterpriseId = useMainEnterpriseId()
  const shopId = useShopId()
  const shopSalePointId = useShopSalePointId()
  const searchText = useItemSearchText()

  const [checkoutStep, setCheckoutStep] = GetAtom(checkoutStepAtom)

  const { isLoading: isLoadingEnterprise, isError: isErrorEnterprise } =
    useEnterpriseGetOne(enterpriseId)
  const { isLoading: isLoadingShop, isError: isErrorShop } = useShopGetOne(
    enterpriseId,
    shopId
  )

  if (
    isLoadingEnterprise ||
    isErrorEnterprise ||
    isLoadingShop ||
    isErrorShop
  ) {
    return null
  }

  return (
    <div>
      <Button
        type="button"
        variant="outline"
        size="lg"
        className="h-12 cursor-pointer px-6 text-base font-medium"
        onClick={async () => {
          await setCheckoutStep(String(Math.max(0, Number(checkoutStep) - 1)))

          if (checkoutStep === "1") {
            await router.push(
              `/e/${enterpriseId}/${shopId}/${shopSalePointId}/sales?${queryString.stringify(
                {
                  searchText: searchText || null,
                },
                { skipNull: true }
              )}`
            )
          }
        }}
      >
        <ArrowLeft className="mr-2 h-5 w-5" />
        Назад
      </Button>
    </div>
  )
}
